var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServiceDetailsPatternMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 234,
    height: 377,
    viewBox: "0 0 234 377",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M140.797 113.954C158.226 113.954 172.355 99.8419 172.355 82.4346C172.355 65.027 158.226 50.9155 140.797 50.9155C123.368 50.9155 109.239 65.027 109.239 82.4346C109.239 99.8419 123.368 113.954 140.797 113.954Z",
    stroke: "currentColor",
    strokeWidth: 13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.784 136.357C97.2956 127.434 83.0217 107.068 83.0217 83.4044C83.0217 51.4974 108.851 25.7002 140.797 25.7002C170.899 25.7002 195.659 48.6849 198.281 78.0704",
    stroke: "currentColor",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5377 147.122C72.9232 132.574 60.2029 109.202 60.2029 82.9195C60.2029 38.6958 96.0334 2.90945 140.312 2.90945C179.638 2.90945 212.458 31.3252 219.158 68.6632",
    stroke: "currentColor",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.859 287.745C302.957 289.103 302.957 290.558 302.957 291.915C302.957 365.331 243.433 424.781 169.928 424.781C96.4217 424.781 36.8986 365.331 36.8986 291.915C36.8986 218.5 96.4217 159.05 169.928 159.05C187.891 159.05 205.078 162.639 220.712 169.039",
    stroke: "currentColor",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.442 393.262C225.751 393.262 271.399 347.67 271.399 291.431C271.399 235.191 225.751 189.6 169.442 189.6C113.133 189.6 67.4855 235.191 67.4855 291.431C67.4855 347.67 113.133 393.262 169.442 393.262Z",
    stroke: "currentColor",
    strokeWidth: 13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.442 372.41C214.221 372.41 250.522 336.155 250.522 291.431C250.522 246.706 214.221 210.451 169.442 210.451C124.663 210.451 88.3623 246.706 88.3623 291.431C88.3623 336.155 124.663 372.41 169.442 372.41Z",
    stroke: "currentColor",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.442 339.922C196.256 339.922 217.993 318.211 217.993 291.431C217.993 264.65 196.256 242.94 169.442 242.94C142.628 242.94 120.891 264.65 120.891 291.431C120.891 318.211 142.628 339.922 169.442 339.922Z",
    stroke: "currentColor",
    strokeWidth: 13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.928 321.98C186.552 321.98 200.029 308.52 200.029 291.915C200.029 275.311 186.552 261.851 169.928 261.851C153.303 261.851 139.826 275.311 139.826 291.915C139.826 308.52 153.303 321.98 169.928 321.98Z",
    stroke: "currentColor",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.568 206.377C232.073 197.067 242.366 190.569 254.115 189.018C255.96 188.727 257.902 188.63 259.747 188.63C282.857 188.63 301.501 207.347 301.501 230.332C301.501 237.606 299.656 244.491 296.355 250.407C290.723 260.59 281.013 268.155 269.36 270.87",
    stroke: "currentColor",
    strokeWidth: 13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.533 193.188C202.554 183.296 210.904 175.052 220.712 169.039C231.684 162.348 244.501 158.565 258.29 158.565C260.62 158.565 262.951 158.662 265.184 158.856C301.888 162.348 330.63 193.188 330.63 230.817C330.63 237.703 329.659 244.297 327.912 250.504C323.639 265.439 314.803 278.338 302.859 287.648C293.732 294.825 282.759 299.868 270.816 301.905",
    stroke: "currentColor",
    strokeWidth: 12,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.428 131.507C209.545 116.087 224.596 105.225 242.268 105.225C252.852 105.225 262.562 109.202 269.942 115.699C273.632 118.997 276.739 122.876 279.167 127.24C282.274 133.156 284.119 139.848 284.119 146.928C284.119 148.382 284.022 149.934 283.925 151.389",
    stroke: "currentColor",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.742 128.113C171.093 92.2298 203.233 65.4628 241.783 65.4628C270.33 65.4628 295.48 80.204 309.851 102.51C315.191 101.734 320.629 101.346 326.261 101.346C391.416 101.346 444.239 154.104 444.239 219.179C444.239 284.157 391.61 336.818 326.649 337.012",
    stroke: "currentColor",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.91 189.891C320.726 189.115 323.639 188.63 326.746 188.63C343.933 188.63 357.819 202.498 357.819 219.664C357.819 236.442 344.516 250.019 327.912 250.698V250.601C331.31 263.694 333.058 277.368 333.058 291.431C333.058 381.721 259.843 454.845 169.442 454.845C79.0406 454.845 5.82611 381.721 5.82611 291.431C5.82611 201.14 79.0406 128.016 169.442 128.016C205.175 128.016 238.287 139.46 265.184 158.856",
    stroke: "currentColor",
    strokeWidth: 13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.145 322.368C385.493 320.331 429.674 274.944 429.674 219.179C429.674 162.154 383.357 115.893 326.261 115.893C323.154 115.893 320.046 115.99 317.036 116.281C311.696 116.766 306.355 117.639 301.209 118.9C299.073 114.245 296.354 109.977 293.246 106.001C281.303 90.775 262.659 80.9799 241.686 80.9799C211.778 80.9799 186.532 100.958 178.667 128.307",
    stroke: "currentColor",
    strokeWidth: 15
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceDetailsPatternMobile);
export default __webpack_public_path__ + "static/media/service-details-pattern-mobile.fe3b3c77.svg";
export { ForwardRef as ReactComponent };